<div
  class="ui container vertical segment"
  [ngClass]="{ loading: pendingArr.length || pending }"
  appMargin
  appPadding
  paddingB="30"
>
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div
        fxLayoutAlign="start center"
        fxLayout="row"
        fxLayoutGap="20px"
        (click)="goBack()"
        class="link"
      >
        <div>
          <img src="assets/icons/left-arrow-icon.svg" alt="" />
        </div>
        <div class="equipment-id">
          <!-- Title -->
          <span class="sub-item">Home > Pay NCC > {{ purpose }} </span>
          <h2 class="ui primary header">Payment Instructions</h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px"></div>
    </div>
    <div class="ui divider"></div>
    <!-- <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div> -->
    <div class="ui success message" *ngIf="success">
      <div class="flex">
        <img src="assets/icons/Frame-check.svg" alt="" />
        <p>Your payment was completed successfully.</p>
      </div>
      <div class="img">
        <img src="assets/icons/x-mark.svg" (click)="closeMessage()" alt="" />
      </div>
    </div>
    <div class="ui error message" *ngIf="error">
      <div class="flex">
        <img src="assets/icons/icon-error.svg" alt="" />
        <p>
          We’re sorry, but your payment was unsuccessful. Please try again to
          complete the transaction.
        </p>
      </div>
      <div class="img">
        <img src="assets/icons/x-mark.svg" (click)="closeMessage()" alt="" />
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="30px" *ngIf="currencyCode == '₦'">
      <div fxFlex="60%" appPadding="7" class="light">
        <div fxLayout="column" fxLayoutGap="20px">
          <div fxFlex>
            <div class="sub-label">PURPOSE/SERVICE</div>
            <div class="sub-value">{{ purpose }}</div>
          </div>

          <div fxFlex>
            <div class="sub-label">BENEFICIARY</div>
            <div class="sub-value">{{ beneficiary }}</div>
          </div>

          <div
            fxFlex
            fxLayout="row"
            fxLayoutGap="15px"
            fxLayoutAlign="space-between"
          >
            <div fxFlex>
              <div class="sub-label">REMITA RETRIEVAL REFERENCE (RRR)</div>
              <h2 class="ui primary header">{{ rrr }}</h2>
            </div>
            <div fxFlex>
              <div class="sub-label">AMOUNT TO PAY</div>
              <h2 class="ui primary header">
                {{ currencyCode }} {{ amount | number: ".2-2" }}
              </h2>
            </div>
          </div>

          <div class="ui divider" appMargin marginY="3"></div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>DESCRIPTION</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ description }}</div>
          </div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>PAYER’S ADDRESS</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ address }}</div>
          </div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>PAYERS’S NAME</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ name }}</div>
          </div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>PAYER’S PHONE</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ phone }}</div>
          </div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>PAYER’S EMAIL</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ email }}</div>
          </div>
        </div>
      </div>

      <div fxFlex="40%" fxLayout="column" fxLayoutGap="10px">
        <div class="ui segment light">
          <div>You can pay this invoice through any of the options below:</div>
        </div>

        <div class="ui segment" id="b-radius">
          <div class="ui content" id="primary">
            Pay with your Debit Card, Internet Banking or via USSD
            <div class="ui divider" appMargin marginB="5"></div>

            <a
              class="ui right floated primary button"
              *ngIf="paymentRedirect"
              [ngClass]="{ disabled: paymentComplete }"
              href="{{ paymentLink }}"
              >Pay Now</a
            >
            <div
              *ngIf="!paymentRedirect"
              class="ui right floated primary button"
              [ngClass]="{ disabled: paymentComplete }"
              (click)="makePayment()"
            >
              Pay Now
            </div>
          </div>
        </div>
        <div class="ui segment" id="b-radius" *ngIf="user.totpEnabled">
          <div class="ui content" id="primary">
            Pay with your eWallet (Balance is {{ nairaWallet?.currencyCode
            }}{{ nairaWallet?.balance | number: ".2-2" }}).
            <div class="ui divider" appMargin marginB="5"></div>

            <button
              class="ui right floated primary button"
              (click)="payWallet(nairaWallet)"
              [disabled]="nairaWallet?.balance < amount || pending"
            >
              Pay Now
            </button>
          </div>
        </div>
        <div class="ui segment" id="b-radius">
          <div class="ui content" id="primary">
            Visit any bank branch with your RRR <strong>{{ rrr }}</strong> to
            make payment
            <div class="ui divider" appMargin marginB="5"></div>

            <a
              class="ui right floated primary button"
              href="{{ baseUrl }}/finance/public/media/?media={{ docPath }}"
              target="_blank"
              >Print Payment Details</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayoutGap="30px"
      *ngIf="!pendingArr.length && currencyCode != '₦'"
    >
      <div fxFlex="60%" appPadding="7" class="light">
        <div fxLayout="column" fxLayoutGap="20px">
          <div fxFlex>
            <div class="sub-label">PURPOSE/SERVICE</div>
            <div class="sub-value">{{ purpose }}</div>
          </div>

          <div fxFlex>
            <div class="sub-label">BENEFICIARY</div>
            <div class="sub-value">{{ beneficiary }}</div>
          </div>

          <div fxFlex fxLayout="row" fxLayoutAlign="">
            <div fxFlex>
              <div class="sub-label">TRANSACTION REFERENCE NUMBER</div>
              <h2 class="ui primary header">{{ rrr }}</h2>
            </div>
            <div fxFlex>
              <div class="sub-label">AMOUNT TO PAY</div>
              <h2 class="ui primary header">
                {{ currencyCode }} {{ amount | number: ".2-2" }}
              </h2>
            </div>
          </div>

          <div class="ui divider" appMargin marginY="3"></div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>DESCRIPTION</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ description }}</div>
          </div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>PAYER’S ADDRESS</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ address }}</div>
          </div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>PAYERS’S NAME</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ name }}</div>
          </div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>PAYER’S PHONE</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ phone }}</div>
          </div>

          <div fxFlex>
            <div>
              <i class="check circle outline icon primary"></i> &nbsp;
              &nbsp;<span style="color: #bbbbc0"
                ><strong>PAYER’S EMAIL</strong></span
              >
            </div>
            <div appMargin marginL="10">{{ email }}</div>
          </div>
        </div>
      </div>

      <div fxFlex="40%" fxLayout="column" fxLayoutGap="10px">
        <div class="ui segment light">
          <div>
            <strong>
              Follow the instructions below to pay this foreign invoice:</strong
            >
            <ul>
              <li appMargin marginB="3">
                Firstly, Pay this USD invoice offline in NCC's stipulated Bank.
                Click
                <!-- <a
                href="{{
                  baseUrl
                }}/public/media/?media=assets\NCC.FOREIGN.ACCOUNT.DETAILS_FEBRUARY_2022_UPDATED_GENERIC.pdf"
                target="_blank"
                >here</a
              > -->
                <a
                  class="ui primary button"
                  target="_blank"
                  routerLink="/home-page/payment-instruction"
                  >here</a
                >
                to view NCC's stipulated USD Bank Account details
              </li>
              <li appMargin marginB="3">
                After you have successfully made the bank payment, Go to
                {{ webUrl }}, navigate to "Pay NCC" menu page, click "check
                payment status" provide your "Transaction Reference Number" and
                submit
              </li>
              <li appMargin marginB="3">
                Click the "Upload proof of payment" button and you will be
                redirected to a page where you are to upload your proof of
                payment
              </li>
            </ul>
          </div>
        </div>

        <div class="ui segment" id="b-radius">
          <div class="ui content" id="primary">
            If you have successfully made your USD bank payment for this
            invoice, Click the "Upload proof of payment" button to proceed
            <div class="ui divider" appMargin marginB="5"></div>

            <a class="ui right floated primary button" href="{{ paymentLink }}"
              >Upload proof of payment</a
            >
          </div>
        </div>
        <div class="ui segment" id="b-radius" *ngIf="user.totpEnabled">
          <div class="ui content" id="primary">
            Pay with your eWallet (Balance is {{ dollarWallet.currencyCode }}
            {{ dollarWallet.balance | number: ".2-2" }}).
            <div class="ui divider" appMargin marginB="5"></div>
            <button
              class="ui right floated primary button"
              [disabled]="dollarWallet.balance < amount || pending"
              (click)="payWallet(dollarWallet)"
            >
              Pay Now
            </button>
          </div>
        </div>
        <div class="ui segment" id="b-radius">
          <div class="ui content" id="primary">
            You can print the payment details for reference purposes
            <div class="ui divider" appMargin marginB="5"></div>

            <a
              class="ui right floated primary button"
              href="{{ baseUrl }}/finance/public/media/?media={{ docPath }}"
              target="_blank"
              >Print Payment Details</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
